export enum GeneralPersonStatus {
  New = 'New',
  Active = 'Active',
  Inactive = 'Inactive',
}
